import React from 'react';
import { ITEM_STATUS } from '../../models/Completion';
import * as CSS from './elements/StatusLight';

export const statusLabels = {
  [ITEM_STATUS.notStarted]: 'Not started',
  [ITEM_STATUS.inProgress]: 'In progress',
  [ITEM_STATUS.complete]: 'Complete',
};

const StatusLight = ({ status, itemId }) => {
  return (
    <CSS.StatusPill
      status={status}
      data-testid={`StatusLight-${itemId}-${status}`}
    >
      <CSS.StatusDot status={status} aria-hidden="true" />
      {statusLabels[status]}
    </CSS.StatusPill>
  );
};

export default StatusLight;
